import lodashDebounce from 'lodash-es/debounce';
import { debounce as localDebounce } from '../functionDebounce';
import { flighted } from '../flighted';

export type { DebouncedFunc, DebouncedFuncLeading } from '../functionDebounce';
export const debounce: typeof localDebounce = flighted(localDebounce, lodashDebounce);
